import React from "react";
import PropTypes from "prop-types";
import "./SideNavigation.css";

export default function SideNavigationMenu(props) {
  return (
    <div className="side-nav-container">
      {/* Main Header Stripe */}
      <div className="side-nav-main-header">
        <h4 className="main-header-title">President's Club</h4>
      </div>
      


    </div>
  );
}

SideNavigationMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isManager: PropTypes.bool
};